import { Menu, Text, Title } from "@mantine/core";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Content } from "shared/components/global/Content";
import { FloatingActionButton } from "shared/components/global/FloatingActionButton/FloatingActionButton";
import { LoadMoreTrigger } from "shared/components/global/LoadMoreTrigger";
import { ScheduledCard } from "shared/components/message/ScheduledCard";
import { usePermissionCheck } from "shared/stores/oidc";
import { createOffsetBasedGqlQueryOptions } from "shared/utils/query";
import { NoMessagesFigure } from "src/assets/NoMessagesFigure";
import { graphql } from "src/gql";
import { Permission } from "src/gql/graphql";
import { queryClient } from "src/queryClient";

const Component = () => {
    const {
        data: { pages },
    } = useSuspenseInfiniteQuery(query);

    const canSendToGroup = usePermissionCheck(Permission.GroupMessageSendTo);
    const canSendToTopic = usePermissionCheck(Permission.TopicMessageSendTo);
    const canSend = canSendToGroup || canSendToTopic;

    const messages = pages.flat();

    return (
        <Content>
            <Content.Heading>
                <Title order={3} size="h1">
                    Scheduled Messages
                </Title>
            </Content.Heading>

            {messages.length == 0 && (
                <NoMessagesFigure>
                    <Text ta={"center"}>Looks like you haven't scheduled any messages yet!</Text>
                </NoMessagesFigure>
            )}
            {messages.map((message) => (
                <ScheduledCard key={message.id} message={message} />
            ))}

            <LoadMoreTrigger query={query} />

            {canSend && (
                <FloatingActionButton>
                    <Menu.Item component={Link} to="/messages/compose">
                        New Message
                    </Menu.Item>
                </FloatingActionButton>
            )}
        </Content>
    );
};

const query = createOffsetBasedGqlQueryOptions({
    document: graphql(`
        query ScheduledMessages($offset: Int!, $limit: Int!) {
            scheduled(limit: $limit, offset: $offset) {
                ...ComposeDetails
            }
        }
    `),
    select: ({ scheduled }) => scheduled,
    queryKey: ["messages", "scheduled"],
});

/** @public */
export const Route = createFileRoute("/_auth/messages/scheduled")({
    shouldReload: false,
    component: Component,
    loader: () => {
        void queryClient.prefetchInfiniteQuery(query);
    },
});
